import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/meh-rolling-eyes': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM336 152c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM336 264c22.1 0 40-17.9 40-40 0-13.6-7.3-25.1-17.7-32.3 1 2.6 1.7 5.4 1.7 8.3 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-3 0.7-5.7 1.7-8.3-10.4 7.2-17.7 18.7-17.7 32.3 0 22.1 17.9 40 40 40zM232 224c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zM120 224c0 22.1 17.9 40 40 40s40-17.9 40-40c0-13.6-7.3-25.1-17.7-32.3 1 2.6 1.7 5.4 1.7 8.3 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-3 0.7-5.7 1.7-8.3-10.4 7.2-17.7 18.7-17.7 32.3zM312 352c13.2 0 24 10.8 24 24s-10.8 24-24 24h-128c-13.2 0-24-10.8-24-24s10.8-24 24-24h128z'
      }
    ]
  }
})
